module.exports = __webpack_public_path__ + "img/snow.be5030ca.webp";